import { connectorInit } from "features/integrations/reducer/ConnectorAction";
import { getOrganizationSettings, getSubscriptionDetails } from "features/settings/reducer/SettingsActions";
import { getAllAuthorizedUsers, getAllRegisteredUsers, getAllRoles, getSettingUser } from "features/settings/reducer/UserActions";
import { getAllWorkspaces } from "features/workspace/reducer/WorkspaceActions";
import { useEffect, useState } from "react";
import { brandValueInit, cxGoalsInit, getAllCxMetrics, getAllInsightTypes, getAllStakeholderRoles, getAllTeams, getNotifs, groupInit, iconsInit, libraryInit, measureInit, priorityInit, statusInit, tagInit, touchPointCategoriesInit, touchPointInit } from "../../redux/index";

export const updateAllStoresStates = async (dispatch) => {
        try{
            await dispatch(getAllWorkspaces())
            await dispatch(getAllRoles())
            await dispatch(getAllAuthorizedUsers())
            await dispatch(getAllRegisteredUsers())
            await dispatch(getAllTeams())
            await dispatch(getSubscriptionDetails())
            await dispatch(getOrganizationSettings())
            await dispatch(getSettingUser())
            await dispatch(connectorInit())
            await dispatch(groupInit())
            await dispatch(iconsInit())
            await dispatch(measureInit())
            await dispatch(priorityInit())
            await dispatch(statusInit())
            await dispatch(tagInit())
            await dispatch(touchPointInit())
            await dispatch(brandValueInit())
            await dispatch(libraryInit())
            await dispatch(getAllInsightTypes())
            await dispatch(getNotifs())
            await dispatch(cxGoalsInit())
            await dispatch(touchPointCategoriesInit())
            await dispatch(getAllStakeholderRoles())
            await dispatch(getAllCxMetrics())
        }catch(error) {
            console.error("Error in updateAllStoresStates:", error);
        }
}

export const useNetworkStatus = () => {
    const [isOnline, setIsOnline] = useState(navigator.onLine);

    useEffect(() => {
        // Update network status
        const handleStatusChange = () => {

            setIsOnline(navigator.onLine);

        };

        window.addEventListener("online", handleStatusChange);
        window.addEventListener("offline", handleStatusChange);

        // Specify how to clean up after this effect for performance improvment
        return () => {
            window.removeEventListener("online", handleStatusChange);
            window.removeEventListener("offline", handleStatusChange);
        };
    }, [isOnline]);

    return { isOnline };
};